<template lang="">
	<ParentGraph
		:title="$t('formulaire')"
		class="flex-center d-block"
		:show="errorImage"
	>
		<div
			class="position-relative"
			:style="errorImage ? 'top: 100px; left: 20px' : ''"
			v-if="!$siteconf.hideImages?.application"
		>
			<img
				ref="Image"
				:src="imageSrc"
				class="position-relative"
			>
		</div>
	</ParentGraph>
</template>
<script>
import { imageErrorHandling} from "@/../public/js/imageErrorHandling"
export default {
	mixins: [imageErrorHandling],

	data() {
		return {
			errorImage: false,
			imageSrc: "/c/images/form",
			fallbackImageSrc: "/s/images/form.png"
		};
	},
	mounted() {
		// Check the image dimensions on mount
		this.preloadImage(this.imageSrc, this.fallbackImageSrc);
	}
	};
</script>
<style lang="scss" scoped>

</style>
